<div class="wrapper-content" *ngIf="card">
  <div class="wrapper-header" style="padding-top: 50px;">
    <a class="btn-back" (click)="route.goBack()" style="text-decoration: none;">
      <svg class="chevron" xmlns="http://www.w3.org/2000/svg" width="28.536" height="17.803"
        viewBox="0 0 28.536 17.803">
        <path id="chevron" d="M2420,308.188l12.5,12.5,12.5-12.5" transform="translate(-2418.232 -306.42)" fill="none"
          stroke="#000" stroke-width="5" />
      </svg> ATRÁS
    </a>
  </div>
</div>
<div class="wrapper-content-fitted" *ngIf="card">

  <div class="wwf-box" *ngIf="card && formView=='register'" style="padding:0 30px ;">
    <h5>
      Para descargar el material por favor complete el formulario
    </h5>

    <form #form="ngForm" (ngSubmit)="register(form)" class="example-form">
      <div class="col-12" style="padding: 0;">
        <mat-form-field class="example-full-width" style="width:100%">
          <mat-label> Nombre </mat-label>
          <input name="name" required #name="ngModel" [(ngModel)]="formData.name" matInput valor="">
        </mat-form-field>
      </div>
      <div class="col-12" style="padding: 0;">
        <mat-form-field class="example-full-width" style="width:100%">
          <mat-label> Correo </mat-label>
          <input name="email" required #email="ngModel" [(ngModel)]="formData.email" matInput valor="">
        </mat-form-field>
      </div>
      <div class="col-12" style="padding: 0;">
        <mat-form-field class="example-full-width" style="width:100%">
          <mat-label> Institución </mat-label>
          <input name="institution" #institution="ngModel" [(ngModel)]="formData.institution" matInput valor="">
        </mat-form-field>
      </div>
      <div class="col-12 text-center" *ngIf="formData.age==false" style="padding: 0;">
        <div class="mb-20" style="font-size: 18px;
          margin-bottom: 20px;
          color: black;
          background: #f5f5f5;
          padding: 10px;">
          <b>Si eres menor de 18 años pide ayuda a un adulto para descargar los recursos.</b>
        </div>
      </div>
      <div class="col-12" style="padding: 0;">
        <mat-checkbox name="age" #age="ngModel" [(ngModel)]="formData.age" class="example-margin">Soy mayor de 18 años
        </mat-checkbox>
      </div>
      <div class="col-12" style="padding: 0;">
        <mat-checkbox name="policy" (click)="openTerms()" #policy="ngModel" [(ngModel)]="formData.policy"
          class="example-margin">Acepto las
          políticas de privacidad
        </mat-checkbox>
      </div>

      <button [disabled]="!formData.policy" [class.disabled]="!formData.policy" type="submit"
        style=" margin: 20px 0; width: 100%; min-width: 100%;" class="btn-theme ts-background-5">
        Registrarme
      </button>

      <a (click)="formView='login'" style=" margin: 20px 0; width: 100%; min-width: 100%;" class="btn-theme">
        Ya estoy registrado </a>

    </form>

    <app-share  *ngIf="card" [name]="card.name"></app-share>
  </div>

  <div class="wwf-box" *ngIf="card && formView=='login'" style="padding:0 30px ;">
    <h5>
      Para descargar el material por favor ingrese su correo electrónico
    </h5>
    <form #form="ngForm" (ngSubmit)="login(form)" class="example-form">

      <div class="col-12" style="padding: 0;">
        <mat-form-field class="example-full-width" style="width:100%">
          <mat-label> Correo </mat-label>
          <input name="email" required #email="ngModel" [(ngModel)]="formData.email" matInput valor="">
        </mat-form-field>
      </div>

      <button [disabled]="!formData.email" [class.disabled]="!formData.email" type="submit"
        style=" margin: 20px 0; width: 100%; min-width: 100%;" class="btn-theme ts-background-5">
        Ingresar
      </button>

      <a (click)="formView='register'" style=" margin: 20px 0; width: 100%; min-width: 100%;" class="btn-theme">
        Registrarme</a>

    </form>

  </div>

  <div class="wwf-box" *ngIf="card && formView=='logued'" style="padding:0 30px ;">
    <h5>
      Hola {{user.visitor ? user.visitor.name:''}},<br>
    </h5>
    <p>El recurso {{card.name}} esta disponible para descargar.</p>
    <a style="margin: 20px auto;" *ngIf="card && user.visitor" target="_blank" href="{{api.route+card.file}}"
      class="btn-theme ts-background-5">Descargar Archivo</a>
    <a (click)="user.forgotVisitor();formView='register'"></a>
    <a (click)="openTerms()">Ver política de privacidad</a>
    <app-share  *ngIf="card" [name]="card.name"></app-share>
  </div>

  <div class="wwf-box">
    <div *ngIf="card" [innerHTML]="card.content.es"></div>
    <div class="wwf-card " magic [magicCss]="{type:'square'}"
      [style.background]="'url('+api.getImageUrl(card.image)+')'">
      <div class="wwf-card--mask" (click)="route.goTo('recursos-formulario/'+card.id)"
      role="img"
      [attr.aria-label]="card.altimage"
        [style.background]="'url('+api.getImageUrl(card.image)+')'">
      </div>
      <div class="wwf-card--body">
        <h4 class="wwf-card--title">{{card.name}}</h4>
      </div>
    </div>
  </div>

</div>
<app-footer *ngIf="card"></app-footer>


<ng-template #content let-modal class="app-modal">
  <!-- <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Política de Uso y Privacidad</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> -->
  <div class="modal-body">
    <div class="col-12">
      <h1>Política de Uso y Privacidad</h1>
      <p>WWF es una de las organizaciones de conservación independientes más grandes y respetadas del mundo, con más de
        5 millones de colaboradores y una red global activa en más de 100 países. La misión de WWF es detener la
        degradación del medio ambiente natural de la Tierra y construir un futuro en el que los humanos vivan en armonía
        con la naturaleza. Estamos presentes en Bolivia desde 1992, trabajando en proyectos y programa de Conservación
        en la Amazonía, el Bosque Seco Chiquitano, el Pantanal, incluyendo un enfoque de ciudades, en La Paz, Santa
        Cruz, Trinidad y Tarija, con acciones de Educación Ambiental.</p>
      <p>La presente política busca regular el uso del sitio web y la información que usted provee a nuestra página.</p>
      <p>El uso de nuestro sitio web expresa su adhesión plena y sin reservas a la presente Política, a través de la
        cual, usted, el usuario, accederá y/o utilizará diversos contenidos, puestos a su disposición.&nbsp;</p>
      <p>Los derechos de propiedad intelectual respecto de los contenidos y los signos distintivos y dominios de nuestro
        sitio web, así como los derechos de uso y explotación del contenido y la información, entre ellos el diseño
        gráfico, las imágenes, los documentos, las investigaciones, los videos, los sonidos, los índices y los códigos
        fuente en lenguaje HTML, u otros análogos o similares, son propiedad exclusiva de WWF, la cual se reserva todos
        los derechos de explotación, con la única excepción de los artículos y opiniones, publicados en el sitio web que
        son propiedad de cada autor individual, en cuyo caso se manifestará su autoría.</p>
      <p>Queda prohibida la reproducción, retransmisión, copia, cesión, radiodifusión o similar, total o parcial de la
        información contenida “la Página Web”, cualquiera que sea su finalidad y el medio que utiliza para conseguirlo,
        sin la expresa autorización de WWF excepto exclusivamente para el uso privado de los usuarios, en cuyo caso
        deberán respetar al autor manteniendo el copyright.</p>
      <p>Queda prohibido también cualquier reproducción o uso del sitio web y sus contenidos con fines comerciales.</p>
      <p>El usuario se compromete a utilizar el sitio web y sus contenidos de modo tal que no atenten contra las normas
        de uso y convivencia en Internet, la Constitución Política del Estado y las Leyes del Estado Plurinacional de
        Bolivia y la legislación vigente en el país en que el usuario se encuentre al usarlos, las buenas costumbres, la
        dignidad de la persona y los derechos de terceros.</p>
      <p>El usuario que tenga acceso a nuestro sitio web, acuerda recibir las cookies que les transmitan los servidores
        de la Institución. "Cookie" significa un archivo de datos que se almacena en el disco duro de la computadora del
        usuario cuando éste tiene acceso al sitio web. Las Cookies pueden contener información tal como la
        identificación proporcionada por el usuario o información para rastrear las páginas que el usuario ha visitado.
        Una Cookie no puede leer los datos o información del disco duro del usuario ni leer las Cookies creadas por
        otros sitios o páginas.</p>
      <p>WWF tiene el derecho de modificar en cualquier momento y sin previo aviso las Políticas de Uso y Privacidad.
        Cuando se actualice, también se cambiará la fecha de "última actualización" en la parte inferior de este
        documento.</p>
      <h3>Privacidad y Protección de la Información Personal.</h3>
      <p>Se protegerá y respetará la privacidad y la información personal de los usuarios de acuerdo a lo prescrito en
        la Constitución Política del Estado, la Ley de Telecomunicaciones y TICs No. 164, sus decretos reglamentarios y
        demás normativa vigente en el Estado Plurinacional de Bolivia.</p>
      <p>WWF no recolecta información personal alguna de sus usuarios, excepto aquella que sea provista a nosotros de
        forma específica y voluntaria por el usuario.</p>
      <p>WWF está comprometida con asegurar la privacidad de tu información personal.</p>
      <p>No venderemos o entregaremos tu información a otra organización externa a WWF, a menos que nos des autorización
        expresa y específica para hacerlo.</p>
      <p>Siempre te daremos la opción de terminar tu suscripción con nuestras listas de correo.</p>
      <p>Si tienes menos de 18 años de edad, sugerimos que consultes con tus padres o guardianes antes de registrarte en
        este sitio.</p>
      <h3>¿Qué información recolectamos?</h3>
      <p>a) Información personal: como nombre, dirección, número telefónico, dirección de correo electrónico y fecha de
        nacimiento (donde sea apropiado). Recolectamos esta información sólo en relación a actividades específicas, como
        membresías, campañas, retroalimentación, encuestas, suscripciones a listas de correo, etc. No es necesario que
        reveles este tipo de información si no lo deseas.</p>
      <p>b) Información no personal: WWF recoge datos tales como direcciones IP (la ubicación del computador en
        Internet), páginas visitadas y archivos descargados. Esto nos ayuda a determinar cuántas personas usan nuestro
        sitio, cuántas personas nos visitan de forma regular, qué páginas son más populares y qué páginas lo son menos.
        Esta información no nos dice nada acerca de tu identidad, sólo nos permite monitorear y mejorar nuestro
        servicio.</p>
      <h3>¿Dónde es almacenada la información?</h3>
      <p>La información personal enviada a través de los formularios en este sitio es almacenada sólo en una base de
        datos de WWF. Aseguramos que WWF no compartirá la información que nos entregues en este sitio con organización
        alguna externa a WWF, a menos que nos hayas permitido específicamente hacerlo.</p>
      <p>Si eres menor de 18 años, asegúrate de obtener permiso de tus padres o guardianes antes de enviar información
        personal (tu nombre, dirección, correo electrónico, etc.) a nosotros o cualquier otra persona a través de
        Internet. Incentivamos a los padres a involucrarse en el uso de Internet de sus hijos y a estar informados
        acerca de las actividades en las que están participando.</p>
      <p>En cualquier momento puedes pedir una copia de la información que mantenemos sobre ti, o pedir que sea
        corregida o borrada.</p>
      <h3>Enlaces externos</h3>
      <p>Hay enlaces en este sitio Web que llevan a otros sitios Web fuera de nuestro servicio. Cualquier enlace a
        sitios externos es provisto nada más que para tu referencia y conveniencia. La operación y contenido de esos
        sitios está más allá de nuestro control, y no respaldamos o de manera alguna nos hacemos responsables por el
        contenido u otro material que pudiera haber en aquellos sitios, el uso de aquellos sitios o cualquier producto o
        servicio publicitado o vendido a través de alguno de esos sitios Web. No seremos responsables bajo circunstancia
        alguna por daños, directos o indirectos, causados por cualquier uso de este sitio Web o algún sitio Web externo
        vinculado este sitio Web, seamos o no informados respecto a la posibilidad de esos daños.</p>
      <p>Si tienes alguna pregunta respecto a nuestra política de uso y privacidad, por favor contáctanos.</p>
      <p>Última actualización: 01/07/2020<br><br></p>
    </div>
    <div class="col-12">
      <a style="display: block;
      margin: auto;
      text-align: center;" class="btn-theme ts-background-5 centered" (click)="modal.close('Save click')">Acepto la
        politica de privacidad</a>
    </div>

  </div>


</ng-template>
